import { Grid } from "@mui/material";
import { NumberInput, ReferenceInput, required, SelectInput, SimpleForm } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import { administrationRequests } from "api/administrationApi";
import { settings } from "app";
import { tenants } from "utils/tenants";

const SaveForm = () => {
  const isMgu = settings.tenant === tenants.MGU;

  return (
    <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={2}
        >
          <NumberInput
            source="fiscalYear"
            label="Календарна година"
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <NumberInput
            source="amount"
            label="Сума"
            validate={required()}
          />
        </Grid>

        {!isMgu && (
          <Grid
            item
            xs={12}
            md={6}
          >
            <ReferenceInput
              source="structuralUnitId"
              reference={administrationRequests.getStructuralUnitsSelect()}
            >
              <SelectInput
                source="name"
                label="Факултет"
                emptyText={false}
                validate={required()}
              />
            </ReferenceInput>
          </Grid>
        )}
      </Grid>
    </SimpleForm>
  );
};

export default SaveForm;
